module.exports = __webpack_public_path__ + "static/media/specialist-care.1d621fff.jpg";